export function prebootstrap(elementId: string) {
  const animData = {
        wrapper: document.getElementById(elementId),
        animType: 'svg',
        loop: true,
        autoplay: true,
        path: './assets/animations/loading/Cinenow_Lauchscreen_v3.json'
    }

  bodymovin.setQuality('low')
  return bodymovin.loadAnimation(animData)
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/prebootstrap.ts